<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="MAC地址">
        <a-input v-model="form.macAddress" disabled />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 确认寄回 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { returnRepairMac } from '@/api/fix/devRepair'

export default {
  name: 'ConfirmShipmentMac',
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-单独寄回MAC设备',
      open: false,
      showLoading: false,

      form: {
        id: undefined,
        macIds: [],
        macAddress: '',
      },

      rules: {
        macIds: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请选择MAC地址'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    reset() {
      this.form = {
        id: undefined,
        macIds: [],
        macAddress: '',
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },

    init(record) {
      this.reset()
      this.form.id = record.id
      this.form.macIds = [record.macId]
      this.form.macAddress = record.macAddress || ''
      this.open = true
    },

    submitForm() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          const submitData = {
            id: this.form.id,
            macIds: this.form.macIds,
          }

          returnRepairMac(submitData)
            .then((response) => {
              this.$message.success('单独寄回操作成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {
              // 错误处理
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>

